



































































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LoadingAnimation extends Vue {
  name: 'LoadingAnimation';

  @Prop({ type: String, default: 'normal' }) readonly displayType: 'normal' | 'blocking';

  @Prop({ type: String, default: '' }) readonly loadingTitle: string;

  elements: {} = {};

  get cssPrefix(): string {
    return ['normal', 'blocking'].includes(this.displayType) ? this.displayType : 'normal';
  }

  get title(): string {
    return this.loadingTitle ?? this.$t('general:non_special_texts.loading');
  }
}
